import './bootstrap';

// require('./formio');

// require jQuery
global.$ = global.jQuery = require('jquery');
global.Swal = global.swal = require('sweetalert2');
global.moment = global.moment = require('moment');